import React, { useState } from 'react';

import { Toolbar, Typography } from '@material-ui/core';
import { Button } from 'react-bootstrap';

import { submissionFields } from '../../../../airtable/metadata/submissions';
import { createColumn } from '../../../components/dynamic-table';
import { ExpandableTable } from '../../../components/expandable-table';
import { createCommonSubmissionsTableColumns } from '../commons/columns';
import { useStyles } from '../commons/styles';
import { getConfirmedSubmissions } from '../commons/utils';

import { SubmissionCardsTable } from './submission-cards-table';
import { UpdateTrackingDialog } from './update-tracking-dialog';

const commonSubmissionsTableColumns = createCommonSubmissionsTableColumns();

export function ConfirmedSubmissionsTable(props) {
  const { allSubmissions, allSubmissionsCards, loading, onUpdateTracking } = props;

  const classes = useStyles();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogSubmission, setDialogSubmission] = useState(null);
  const [dialogValue, setDialogValue] = useState(null);

  const confirmedSubmissions = getConfirmedSubmissions(allSubmissions, allSubmissionsCards);

  // if (confirmedSubmissions.length <= 0) {
  //   return null;
  // }

  const confirmedSubmissionsTableColumns = [
    ...commonSubmissionsTableColumns,
    createColumn('Actions', {
      align: 'right',
      colSpan: 1,
      size: 'small',
      sortable: false,
      render: submission => {
        return <Button
          className={classes.submitButton}
          disabled={loading}
          type="button"
          variant="primary"
          onClick={event => {
            setDialogOpen(true);
            setDialogSubmission(submission);
            setDialogValue(submission?.fields[submissionFields.TRACKING_NUMBER]);
            event.stopPropagation();
          }}
        >
          <span>Update tracking</span>
          {loading && <span className="ml-3 spinner spinner-white" />}
        </Button>;
      },
    }),
  ];

  return (
    <>
      <Toolbar className={classes.toolbar}>
        <Typography variant="h6">My submissions</Typography>
      </Toolbar>

      <ExpandableTable columns={confirmedSubmissionsTableColumns} rows={confirmedSubmissions}>
        {row => (
          <SubmissionCardsTable
            allSubmissionsCards={allSubmissionsCards}
            submission={row}
          />
        )}
      </ExpandableTable>

      <UpdateTrackingDialog
        onClose={() => setDialogOpen(false)}
        onSave={value => onUpdateTracking(dialogSubmission, value)}
        open={dialogOpen}
        value={dialogValue}
      />
    </>
  );
}
